import React from "react";

import { useAppSelector } from "cortex/ui/src/hooks";
import { getAuthUser } from "cortex/ui/src/redux-store/auth/selectors";
import FullDeviceListTable from "cortex/ui/src/ui/full-device-list/FullDeviceListTable";
import WsDsConnStatus from "cortex/ui/src/ui/ws-ds-conn-status/WsDsConnStatus";
import { Container } from "cortex/ui/src/view/layout";

export default function FullDeviceList() {
  const user = useAppSelector(getAuthUser);
  return (
    <Container hideBox title="Devices">
      <WsDsConnStatus />
      <FullDeviceListTable
        storageKey={`devices_acct_${user?.account_id ?? 0}`}
      />
    </Container>
  );
}
